module.exports = __webpack_public_path__ + "img/cx2.58eb1f95.png";